import { l as library } from './index.es-959dd499.js';

// Store icons in map to always return the same instance of icon depending on icon lookup
const ICON_MAP = new Map();
// Referenced from https://github.com/FortAwesome/react-fontawesome/blob/master/src/utils/normalize-icon-args.js
const getPrefixAndName = (icon) => {
  // if it's an array with length of two
  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return { prefix: icon[0], iconName: icon[1] };
  }
  // if the icon is an object and has a prefix and an icon name, return it
  if (typeof icon === 'object') {
    const { prefix, iconName } = icon;
    return { prefix, iconName };
  }
  // if it's a string, use it as the icon name
  if (typeof icon === 'string') {
    return { prefix: 'fas', iconName: icon };
  }
};
const getIconKey = (icon) => {
  const { prefix, iconName } = getPrefixAndName(icon);
  return `${prefix}-${iconName}`;
};
const addIcon = (icon) => {
  const iconKey = getIconKey(icon);
  library.add(icon);
  ICON_MAP.set(iconKey, icon);
};

export { ICON_MAP as I, addIcon as a, getIconKey as g };
